export default __webpack_public_path__ + "static/media/print_estimate_shanai_3.294c5301.svg";